import type { ImgHTMLAttributes } from "react";

interface SafeImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  /** Optional focal point for an explicitly cover-cropped image. */
  portraitPosition?: string;
}

/**
 * A deliberately small image primitive. Cropping is never inferred from
 * orientation: callers choose the fit through the surrounding PhotoFrame.
 */
export function SafeImage({ onLoad, portraitPosition, style, ...props }: SafeImageProps) {
  return (
    <img
      {...props}
      style={{ ...style, ...(portraitPosition && !style?.objectPosition ? { objectPosition: portraitPosition } : {}) }}
      onLoad={onLoad}
    />
  );
}
